import client1 from "../assets/images/1.png";
import client2 from "../assets/images/2.png";
import client3 from "../assets/images/3.png";
import client4 from "../assets/images/4.png";
import client5 from "../assets/images/5.png";
import client6 from "../assets/images/6.png";
import client7 from "../assets/images/7.png";
import client8 from "../assets/images/8.png";
import client9 from "../assets/images/9.png";
import client10 from "../assets/images/10.png";
import client11 from "../assets/images/11.png";
import client12 from "../assets/images/12.png";
import client13 from "../assets/images/13.png";
import client14 from "../assets/images/14.png";
import client15 from "../assets/images/15.png";
import client16 from "../assets/images/16.png";
import client17 from "../assets/images/17.png";
import client18 from "../assets/images/18.png";
import "./Clients.css";

const Clients = () => {
  return (
    <section className="clients">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="sub-title text-center mb-4">Clients</h2>
            <h2 className="main-title text-center split-text" id="split-text" data-splitting>
              Businesses We’re Proud to Work With
            </h2>
          </div>
        </div>
        <div className="row">
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client1} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client2} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client3} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client4} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client5} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client6} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client7} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client8} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client9} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client10} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client11} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client12} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client13} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client14} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client15} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client16} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client17} className="img-fluid" alt="" />
            </div>
          </div>
          <div className="col-lg-2 col-md-4 col-6 text-center">
            <div className="client-logo">
              <img src={client18} className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Clients;
